import { objectWithoutPropertiesLoose as _objectWithoutPropertiesLoose } from '../../_virtual/_rollupPluginBabelHelpers.js';
import { forwardRef, createElement } from 'react';
import cn from 'classnames';
import { IconButton } from '../IconButton/IconButton.js';
import { useGaudiLocalization } from '../Provider/Provider.js';
import { Calendar } from '../Calendar/Calendar.js';
import { Input } from '../Input/Input.js';
import { PopoverDisclosure, Popover } from 'reakit';
import { useDatepicker } from './useDatepicker.js';

var _excluded = ["className", "style"];
var Datepicker = /*#__PURE__*/forwardRef(function Datepicker(props, ref) {
  var externalClassName = props.className,
      style = props.style,
      otherProps = _objectWithoutPropertiesLoose(props, _excluded);

  var _useDatepicker = useDatepicker(otherProps, ref),
      calendar = _useDatepicker.calendar,
      input = _useDatepicker.input,
      popover = _useDatepicker.popover;

  var _useGaudiLocalization = useGaudiLocalization(),
      texts = _useGaudiLocalization.texts;

  var className = cn('yt-datepicker', externalClassName);
  return createElement("span", {
    className: className,
    style: style
  }, createElement(Input, Object.assign({}, input, {
    button: createElement(PopoverDisclosure, Object.assign({}, popover, {
      disabled: input.disabled
    }), function (disclosureProps) {
      var _input$disabled;

      return createElement(IconButton, Object.assign({}, disclosureProps, {
        "aria-label": texts.datepicker.expand,
        disabled: (_input$disabled = input.disabled) !== null && _input$disabled !== void 0 ? _input$disabled : input.readOnly,
        icon: "calendar"
      }));
    })
  })), createElement(Popover, Object.assign({}, popover, {
    className: "yt-datepicker__popover",
    "aria-label": texts.datepicker.calendar
  }), createElement(Calendar, Object.assign({}, calendar))));
});

export { Datepicker };
//# sourceMappingURL=Datepicker.js.map
